import { create } from 'zustand';
import { createJSONStorage, persist, type StateStorage } from 'zustand/middleware';
import { CreateJobRequest } from '../types';
import { HYDRATING } from '../utils/hydrating';
import { safeLocalStorage } from '../utils/safeStorage';

interface GuestJobState {
    pendingJob: CreateJobRequest | null;
    setPendingJob: (job: CreateJobRequest) => void;
    clearPendingJob: () => void;
    hasPendingJob: () => boolean;
}

export const useGuestJobStore = create<GuestJobState>()(
    persist(
        (set, get) => ({
            pendingJob: null,

            setPendingJob: (job: CreateJobRequest) => {
                set({ pendingJob: job });
            },

            clearPendingJob: () => {
                set({ pendingJob: null });
            },

            hasPendingJob: () => {
                return get().pendingJob !== null;
            },
        }),
        {
            name: 'bricolat_guest_job',
            // Without a usable storage, zustand would not attach `.persist` at all (see main.tsx).
            storage: createJSONStorage((): StateStorage<unknown> => safeLocalStorage),
            skipHydration: HYDRATING,
            // Only persist the pendingJob data
            partialize: (state) => ({ pendingJob: state.pendingJob }),
        }
    )
);
